import script from "./PresentacionCapacitacionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentacionCapacitacionComponent.vue?vue&type=script&setup=true&lang=js"

import "./PresentacionCapacitacionComponent.vue?vue&type=style&index=0&id=351ac532&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351ac532"]])

export default __exports__